import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import CrossDomain from "./Pages/CrossDomain";
import { CookiesProvider } from "react-cookie";

const App = () => (
  <BrowserRouter basename="/react-form-plugin">
    <CookiesProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="cross-domain" element={<CrossDomain />} />
      </Routes>
    </CookiesProvider>
  </BrowserRouter>
);

export default App;
